export var temporal = {
    formatDate: function (dateString, format) {
        if (!dateString)
            return format !== null && format !== void 0 ? format : '--/--/----';
        var date = new Date(dateString);
        var pad = function (n) { return n.toString().padStart(2, '0'); };
        var day = pad(date.getDate());
        var month = pad(date.getMonth() + 1); // Month is 0-indexed
        var year = date.getFullYear();
        var hours = pad(date.getHours());
        var minutes = pad(date.getMinutes());
        var seconds = pad(date.getSeconds());
        return (format == 'dd/mm/yyyy hh:mm:ss') ? "".concat(day, "/").concat(month, "/").concat(year, " ").concat(hours, ":").concat(minutes, ":").concat(seconds) : (format == 'dd/mm/yyyy hh:mm') ? "".concat(day, "/").concat(month, "/").concat(year, " ").concat(hours, ":").concat(minutes) : "".concat(day, "/").concat(month, "/").concat(year);
    }
};
